import {TranslationKeyAuth} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_AUTH_EN: TranslationResource<TranslationKeyAuth> = {
  translation: {
    'auth:banModalDescription':
      'Sorry, your account has been banned for violating the FotoYu Community guidelines. You can read our community guidelines again here.',
    'auth:banModalUnderageDescription':
      'Sorry, your account has been banned due to your insufficient age as specified in the Terms of User. You can read our Terms of Use again.',
    'auth:banModalTitle': 'Your account has been banned',
    'auth:confirmationPassword': "New password doesn't match",
    'auth:createPasswordSSOConfirmationPlaceholder': 'Confirm your password',
    'auth:createPasswordSSODesc':
      'Before we continue, please create a password for transaction purpose.',
    'auth:createPasswordSSOTitle': 'Create Password',
    'auth:deleteAccountAssociateHost':
      'Your account is still associated with a host, please demote your account from host.',
    'auth:deleteAccountOweResend':
      "You still haven't sent a Hi-Res file to the Yuser, please send the file first.",
    'auth:filterDateValidation': "From date can't be greater than To date",
    'auth:forgotPasswordEmailDescription':
      'A link has been sent to your email to continue the process. Please check your email inbox.',
    'auth:forgotPasswordHeader': 'Forgot Password',
    'auth:forgotPasswordHeaderDescription':
      'Let us know where to contact you right away.',
    'auth:forgotPasswordInputLabel': 'Email or Mobile Number',
    'auth:forgotPasswordInputPlaceholder': 'Input your email or mobile no.',
    'auth:forgotPasswordPhoneDidNotGet': "Didn't get the link?",
    'auth:forgotPasswordPhoneDescription':
      'A verification link is sent to your mobile number. Please check your SMS.',
    'auth:forgotPasswordPhoneDescription_whatsapp':
      'A verification link is sent to your mobile number. Please check your WhatsApp.',
    'auth:forgotPasswordPhoneResend': 'Resend link',
    'auth:forgotPasswordPhoneResendCountdown': 'Resend link ({{countdown}}s)',
    'auth:forgotPasswordResendMessage':
      'Sorry! Please wait about {{cooldown}} minutes before continuing.',
    'auth:forgotPasswordResendMessageLimit':
      'Sorry! Please wait <hourStamp>{{hour}}h</hourStamp><minuteStamp>{{minute}}m</minuteStamp><secondStamp>{{second}}s</secondStamp> before continuing.',
    'auth:inputPasswordConfirmLabel': 'Confirm New Password',
    'auth:inputPasswordConfirmPlaceholder': 'Input your new password again',
    'auth:identifierOneAccount': 'Each person is only able to have 1 account.',
    'auth:linkExpiredHeader': 'Link Expired',
    'auth:linkExpiredHeaderDescription': 'The link has expired.',
    'auth:linkExpiredInformation': "Didn't get the link?",
    'auth:linkExpiredResend': 'Resend link',
    'auth:linkSuccessHeader': 'Success!',
    'auth:loginButtonAppleTitle': 'Login with Apple',
    'auth:loginButtonGoogleTitle': 'Login with Google',
    'auth:loginForgotPassword': 'Forgot / Create Password',
    'auth:loginHeader': 'Welcome Back',
    'auth:loginHeaderDescription': 'Login to enjoy FotoYu.',
    'auth:loginInputAccountLabel': 'Username, Email, or Mobile Number',
    'auth:loginInputAccountPlaceholder':
      'Input your username, email, or mobile no.',
    'auth:loginInputPasswordLabel': 'Password',
    'auth:loginInputPasswordPlaceholder': 'Input your password',
    'auth:loginNotHaveAccount': "Don't have an account?",
    'auth:loginUnderage': 'Parental Consent Required',
    'auth:loginUnderageHeader':
      'You are under 13 years old and identified as a Child Yuser.',
    'auth:loginUnderageDescription':
      'You need a parental consent (parent needs to create an account)',
    'auth:logoutModalExpiredTokenDescription':
      'No worry, you just need to log in again.',
    'auth:logoutModalTitle': 'Your session has expired',
    'auth:messageBackToLogin': 'Back to Login',
    'auth:messageBackToProfile': 'Back to Profile',
    'auth:nicknameAllowedCharacters':
      'Nickname should be alphanumeric, (_), (-), and (.)',
    'auth:nicknameCreated': 'Your nickname has been created.',
    'auth:nicknameLabelDescription': 'For content purchases only',
    'auth:nicknameSublabel': 'Enter a nickname different than your username',
    'auth:registerDateOfBirthInputPlaceholder': 'DD/MM/YYYY',
    'auth:registerAppleButtonLabel': 'Sign Up with Apple',
    'auth:registerGoogleButtonLabel': 'Sign Up with Google',
    'auth:registerHeader': 'Create Account',
    'auth:registerHeaderDateOfBirth': 'When Were You Born?',
    'auth:registerHeaderPassword': 'Create Password',
    'auth:registerHeaderAccount': 'Create Account',
    'auth:registerCreateAccountThroughMobileApp':
      'Create your account through FotoYu mobile app.',
    'auth:registerDoBDescription': 'Age under {{age}} needs a parental consent',
    'auth:registerIdentifierAlreadyHaveAnAccount': 'Already have an account?',
    'auth:registerIdentifierCancelModalMessage':
      'Are you sure want to cancel? The data will not be saved',
    'auth:registerIdentifierInputEmailLabel': 'Email',
    'auth:registerIdentifierInputEmailPlaceholder': 'someone@domain.com',
    'auth:registerIdentifierInputPhoneLabel': 'Mobile Number',
    'auth:registerIdentifierInputPhonePlaceholder': 'e.g.: 878761234',
    'auth:registerIdentifierSearchCountryEmpty': `Oh no! We can't find country "{{search}}"`,
    'auth:registerIdentifierTabEmail': 'Email',
    'auth:registerIdentifierTabPhone': 'Mobile Number',
    'auth:registerLimitReached': 'Please try again in 24 hours',
    'auth:resendLimitReached': 'Please try again in {{duration}}',
    'auth:registerMinimumAgeErrorMessage':
      'Minimum age is {{minAge}} years old',
    'auth:registerPasswordConfirmationMessage': 'Input your password again',
    'auth:registerPasswordInputPlaceholder': 'Create your password',
    'auth:registerTermsOfService':
      'By signing up, you agree to the <tos>Terms of Use</tos> and <privacy>Privacy Policy</privacy>, including <cookie>Cookies Policy</cookie>. You may receive email notifications from us and can opt out at any time.',
    'auth:registerTermsOfService_phone':
      'By signing up, you agree to the <tos>Terms of Use</tos> and <privacy>Privacy Policy</privacy>, including <cookie>Cookies Policy</cookie>. You may receive SMS notifications from us and can opt out at any time.',
    'auth:registerUnderage':
      'Sorry, you are still underage and need a parental consent. Please download FotoYu mobile app.',
    'auth:registerUsernameInputPlaceholder': 'Create your username',
    'auth:resetPasswordButtonTitle': 'Reset Password',
    'auth:resetPasswordHeader': 'Reset Password',
    'auth:resetPasswordHeaderDescription':
      'Remember your password to enjoy FotoYu seamlessly!',
    'auth:resetPasswordSuccessDescription':
      'Now you can log in using your new password. Welcome!',
    'auth:resetPasswordSuccessSubtitle': 'Your password has been changed.',
    'auth:serverUnderMaintenance': 'Server Under Maintenance',
    'auth:serverUnderMaintenanceDescFirst':
      'Service will be restored in a short time.',
    'auth:serverUnderMaintenanceDescSecond': 'Sorry for the inconvenience.',
    'auth:similarIdentityButton': 'Choose an Account',
    'auth:similarIdentityDescFirst':
      'We took privacy issues seriously and strictly against any illegal attempts to impersonate others or spoofing. We always try to protect the safety of users from identity theft.',
    'auth:similarIdentityDescSecond':
      'To continue using our app, you need to choose an account that you want to activate.',
    'auth:similarIdentitySnackbar': 'Thank you! We will contact you shortly.',
    'auth:suspendLoginModalDescription':
      'You have exceeded the login attempts limit. Please try again in 5 minutes.',
    'auth:suspendModalDescription':
      'Sorry, based on your last activities, your account has been temporarily suspended because it violates our community guidelines.',
    'auth:suspendModalTitle': 'Your Account Has Been Suspended',
    'auth:unverifiedEmailSnackbar': 'Please check your email inbox.',
    'auth:validationCreatePasswordSSO':
      'Password tidak bisa mengandung spasi, huruf non-Romawi, atau emoji',
    'auth:validationEmail': 'Please enter the correct email format',
    'auth:validationEmailEmpty': 'Please enter an email',
    'auth:validationEmailExpired': 'Link has expired. Please try again',
    'auth:validationEmailFormat':
      'Please enter your email address in format: name@example.com',
    'auth:validationEmailHasBeenTaken': 'Email has been registered',
    'auth:validationLoginMissMatch':
      "We couldn't find any account matched to your credential and password. Please check and try again.",
    'auth:validationLoginNoPasswordMissmatch':
      "No password set for this account. Click 'Forgot Password' to add a password or tap login with Google / Apple",
    'auth:validationLoginSSOMissMatch':
      'Your account is registered using Google/Apple, please try logging in by tapping login with Google or Apple.',
    'auth:validationForgotPasswordSSOMissMatch':
      'Your account is registered using Google/Apple, therefore you cannot forgot your password. Please try logging in by tapping login with Google or Apple.',
    'auth:validationLoginAttempt':
      'Sorry! Wrong password. You have {{attempt}} chances left.',
    'auth:validationMandatoryField': 'All mandatory fields must be filled',
    'auth:validationNicknameHasBeenTaken':
      'This nickname has already been taken by another user.',
    'auth:validationNicknameIsEmpty': 'Nickname must be filled',
    'auth:validationNicknameMatchUsername':
      'Your nickname is the same as your username. Please change your nickname',
    'auth:validationNicknameMaxLength': 'Maximal char is {{count}}',
    'auth:validationNicknameMinLength':
      'Your nickname is too short. Minimal character is {{count}}',
    'auth:validationNicknameNoSpace': 'Nickname cannot contain spaces',
    'auth:validationNicknameOneLetterRequired':
      'Nickname must contain at least one letter',
    'auth:validationNicknameSingleDash':
      'Nickname can only contain one dash (-)',
    'auth:validationNicknameSinglePeriod':
      'Nickname can only contain one period (.)',
    'auth:validationNicknameSingleUnderscore':
      'Nickname can only contain one underscore (_)',
    'auth:validationNicknameStartCharacter': 'Nickname must start with letter',
    'auth:validationNicknameStartEndAlphanumeric':
      'Nickname cannot start or end with an underscore (_), dash (-), or period (.)',
    'auth:validationPassword': 'Consist of alphabets and numeric',
    'auth:validationPasswordConfirmation': 'Are you sure to use this password?',
    'auth:validationPasswordError':
      'Password must consist of alphabets and numeric',
    'auth:validationPasswordLength':
      'Consist of at least {{minLength}} characters',
    'auth:validationPasswordMaxLength': 'Maximum character is {{count}}',
    'auth:validationPasswordMinLength':
      'Password must be at least {{count}} character',
    'auth:validationPasswordMinLength_plural':
      'Password must be at least {{count}} characters',
    'auth:validationPasswordMix':
      'Password must consist of alphabets and numeric',
    'auth:validationPasswordNoDashUnderscorePeriod':
      'Password cannot contain underscore (_), dash (-), or period (.)',
    'auth:validationPasswordNoNonRomanCharacters':
      'Password cannot contain non-Roman letter or emoji',
    'auth:validationPasswordNoSpace': 'Password cannot contain spaces',
    'auth:validationPhone': 'Phone number must be numeric',
    'auth:validationPhoneEmpty': 'Please enter a phone number',
    'auth:validationPhoneHasBeenTaken': 'Phone number has been registered',
    'auth:validationPhoneMinLength':
      'Phone number must contain a minimum {{count}} characters',
    'auth:validationPhoneMinLength_plural':
      'Mobile number must contain a minimum of {{count}} characters',
    'auth:validationPhoneRegistered':
      "Sorry! Looks like this mobile number has been registered. Let's use another mobile number and try again.",
    'auth:validationRequired': 'This field is required',
    'auth:validationResetPasswordMustBeDifferent':
      'Must be different than old password',
    'auth:validationResetPasswordNotMatch': 'New password does not match',
    'auth:validationUsername': 'Username should be alphanumeric, (_), and (-)',
    'auth:validationUsernameSimilar':
      'Username should be alphanumeric, (_), (-), and (.)',
    'auth:validationUsernameContainsFotoyu': 'Username cannot contain FotoYu',
    'auth:validationUsernameHasBeenRegistered': 'Username has been registered',
    'auth:validationUsernameHasBeenTaken': 'Your username is already taken',
    'auth:validationUsernameLength':
      'Username must be at least {{count}} character',
    'auth:validationUsernameMinLength': 'Minimum is {{count}} character',
    'auth:validationUsernameMinLength_plural':
      'Username must be at least {{count}} characters',
    'auth:validationUsernameNoSpaceAndSpecialCharacter':
      'Username cannot contain spaces or special character',
    'auth:validationUsernameNotOnlyNumbers':
      'Username cannot contain only numbers',
    'auth:validationUsernameSinglePeriod':
      'Username can only contain one underscore (_), dash (-)',
    'auth:validationUsernameStartEndAlphanumeric':
      'Username cannot start or end with an underscore (_) or dash (-)',
    'auth:validationUsernameStartEndNoSpecial':
      'Username cannot contain spaces',
    'auth:validationUsernameStartWithLetter': 'Username must start with letter',
    'auth:validationVerificationOTPInvalid':
      "We couldn't authenticate the OTP. Please try again.",
    'auth:validationWesbite':
      "Website must starts with 'https://' or 'http://'",
    'auth:validationWesbiteURL':
      'The link is not valid. Please check your link format.',
    'auth:verificationCheckBox':
      'By signing up, you agree to the Terms of Use and Privacy Policy, including Cookies Policy. You may receive SMS notifications from us and can opt out at any time.',
    'auth:verificationEmailCaution': 'Your verification link expires in',
    'auth:verificationEmailCautionTime': '1 hour.',
    'auth:verificationEmailConfirmHeaderDescription':
      'Your account has been verified.',
    'auth:verificationEmailConfirmInformation':
      'Now you can log in using your registered email. Enjoy!',
    'auth:verificationEmailDidNotGet': "Didn't get the email?",
    'auth:verificationEmailHeader': '{{email}}',
    'auth:verificationEmailHeaderDescription':
      'We have sent you a verification email. Please check your email for confirmation link.',
    'auth:verificationEmailInformation':
      'Account confirmation is required. Please check your email for confirmation link.',
    'auth:verificationEmailResend': 'Resend email',
    'auth:verificationEmailResendCountdown': 'Resend email ({{countdown}}s)',
    'auth:verificationEmailSent':
      'Confirmation email sent to this email address',
    'auth:verificationPhoneCaution': 'Your OTP expires in',
    'auth:verificationPhoneCautionTime': ' 5 minutes.',
    'auth:verificationPhoneConfirmHeader': 'Success!',
    'auth:verificationPhoneConfirmHeaderDescription':
      'Your mobile number has been verified.',
    'auth:verificationPhoneConfirmHeaderInformation':
      'Now you can log in using your registered mobile number. Enjoy!',
    'auth:verificationPhoneDidNotGet': "Didn't get the OTP?",
    'auth:verificationPhoneHeaderDescription':
      'An OTP is sent to your mobile number. Please check your SMS.',
    'auth:verificationPhoneHeaderDescription_whatsapp':
      'An OTP is sent to your mobile number. Please check your WhatsApp.',
    'auth:verificationPhoneInputPlaceholder': 'Your 4-digits OTP',
    'auth:verificationPhoneOTP': 'OTP has expired',
    'auth:verificationPhoneResend': 'Resend OTP',
    'auth:verificationPhoneResendCountdown': 'Resend OTP ({{countdown}}s)',
    'auth:verifyAccount': 'Please verify your account to continue',
    'auth:waitingModalInfo':
      'Due to high demand, we are increasing the capacity of our server.',
    'auth:waitingModalDescription':
      'Currently, you are on the waiting list. We will inform you when our capacity has increased. Thank you for your patience.',
    'auth:waitingModalTitle': 'Sorry!',
    'auth:wefieHeader': 'Wefie',
    'auth:wefieThroughMobileApp':
      'Login your account through FotoYu mobile app, and do wefie with your children.',
    'auth:wefieReapplyModalDescription':
      'Please make sure that all requirements are correct, and try again.',
    'auth:wefieReapplyModalTitle':
      "You can't log in, because we found your wefie doesn't meet the requirements.",
    'auth:wefieWaitingModalDescription':
      'RoboYu will inform you as soon as possible after the process is done.',
    'auth:wefieWaitingModalTitle':
      "You can't log in, because your wefie has not been approved by RoboYu.",
  },
}
